<template>
    <div class="btn-group">
        <template v-for="tab in tabs">
            <router-link class="btn btn-default shadow-none" :to="tab.target" :class="{ active: tab.active }" @click.native="getSoundClick" v-if="tab.visible">{{ $t(tab.label) }}</router-link>
        </template>
    </div>
</template>
<script>
import { soundClick } from '../utils/utils';

export default {
    name: 'NavTabs',
    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
        tabs() {
            const current = this.$route.name
            return [
                { label: 'report', target: { name: 'parent_report' }, active: current === 'parent_report', visible: true },
                { label: 'certificate', target: { name: 'parent_certificate' }, active: current === 'parent_certificate', visible: this.user_info.student_type == 1 },
                { label: 'feedback', target: { name: 'parent_feedback' }, active: current === 'parent_feedback', visible: false },
                { label: 'account_information', target: { name: 'parent_account' }, active: current === 'parent_account', visible: true },
                { label: 'upgrade_account', target: { name: 'upgrade_account' }, active: current === 'upgrade_account', visible: true },
                { label: 'upgrade_feature', target: { name: 'upgrade_feature' }, active: current === 'upgrade_feature', visible: true },
                { label: 'iCLASS', target: { name: 'parent_iclass_report' }, active: current === 'parent_iclass_report', visible: true },
            ]
        }
    },

    methods: {
        getSoundClick() {
            soundClick();
        },
    }
}
</script>